import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  apps: [],
  selectedApp: null,
  scripts: [],
  searchTerm: "",
  kindFilter: "all",
  ssoFilter: "all",
  capabilityFilter: "all",
  loading: false,
  error: null,
};

const appRegistrySlice = createSlice({
  name: "appRegistry",
  initialState,
  reducers: {
    fetchAppsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAppsSuccess(state, action) {
      state.apps = action.payload;
      state.loading = false;
    },
    fetchAppsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedApp(state, action) {
      state.selectedApp = action.payload;
    },
    clearSelectedApp(state) {
      state.selectedApp = null;
      state.scripts = [];
    },
    setScripts(state, action) {
      state.scripts = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setKindFilter(state, action) {
      state.kindFilter = action.payload;
    },
    setSsoFilter(state, action) {
      state.ssoFilter = action.payload;
    },
    setCapabilityFilter(state, action) {
      state.capabilityFilter = action.payload;
    },
  },
});

export const {
  fetchAppsStart,
  fetchAppsSuccess,
  fetchAppsFailure,
  setSelectedApp,
  clearSelectedApp,
  setScripts,
  setSearchTerm,
  setKindFilter,
  setSsoFilter,
  setCapabilityFilter,
} = appRegistrySlice.actions;

export default appRegistrySlice.reducer;
